/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'outdent': {
    width: 30,
    height: 28,
    viewBox: '0 0 30 28',
    data: '<path pid="0" data-name="形状 1" d="M8 8l-8 6 8 6V8z" fill-rule="evenodd" _fill="#a6a6a6"/><path pid="1" data-name="矩形 1" _fill="#a6a6a6" d="M0 0h30v4H0z"/><path pid="2" data-name="矩形 1 拷贝" _fill="#a6a6a6" d="M12 8h18v4H12z"/><path pid="3" data-name="矩形 1 拷贝 2" _fill="#a6a6a6" d="M12 16h18v4H12z"/><path pid="4" data-name="矩形 1 拷贝 3" _fill="#a6a6a6" d="M0 24h30v4H0z"/>'
  }
})
